import { parsePhoneNumberFromString } from "libphonenumber-js";

const yup = require("yup");
const dayjs = require("dayjs");
const { generateCustomFieldsValidation } = require("./customFieldValidations");
const { addressValidation } = require("./addressValidation");

const users = yup.object().shape({
  firstName: yup
    .string()
    .matches(
      /^[A-Za-z ]*$/,
      "First Name can only contain alphabetic characters and spaces",
    )
    .required("First Name is required"),
  lastName: yup
    .string()
    .matches(
      /^[A-Za-z ]*$/,
      "Last Name can only contain alphabetic characters and spaces",
    )
    .required("Last Name is required")
    .test(
      "nameLength",
      "First Name and Last Name together should not exceed 24 characters. This will be printed on the card.",
      function (value) {
        const { firstName } = this.parent;
        return (firstName?.length || 0) + (value?.length || 0) <= 24;
      },
    ),
  email: yup
    .string()
    .email("Email Address is not valid")
    .required("Email Address is required"),
  phone: yup
    .string()
    .test("isPhoneValid", "Phone Number is not valid", (phoneNumber) => {
      if (!phoneNumber) return false;
      const parsedPhoneNumber = parsePhoneNumberFromString(phoneNumber, "US");
      return parsedPhoneNumber ? parsedPhoneNumber.isValid() : false;
    })
    .required("Phone Number is required"),
  address: addressValidation,
  employeeGroup: yup.string(),
  role: yup.string().required("Role is required"),
  status: yup.string(),
  location: yup.object().shape({
    id: yup.string().required("Business Location is required"),
  }),
  assignedManager: yup.object().shape({
    id: yup.string().optional(),
    userName: yup.string(),
  }),
  sendOneTime: yup.boolean().optional(),
  birthdate: yup
    .date()
    .transform(function (value, birthdate) {
      return dayjs(birthdate).isValid() ? dayjs(birthdate).toDate() : null;
    })
    .required("Date of birth is required")
    .typeError("Enter a valid date of birth")
    .test("age", "You must be at least 18 years old", function (value) {
      return value ? dayjs().diff(dayjs(value), "year") >= 18 : false;
    })
    .test("age", "Enter a valid date of birth", function (value) {
      return value ? dayjs().diff(dayjs(value), "year") < 150 : false;
    }),
});

// Function to dynamically add custom fields to the base schema
const generateUserValidationSchema = (customFieldSettings = []) => {
  const customFieldsSchema =
    generateCustomFieldsValidation(customFieldSettings); // Generate custom fields schema
  return users.concat(
    yup.object({
      customFields: customFieldsSchema, // Add custom fields validation
    }),
  );
};

const platformUsers = yup.object().shape({
  firstName: yup
    .string()
    .matches(
      /^[A-Za-z ]*$/,
      "First Name can only contain alphabetic characters and spaces",
    )
    .required("First Name is required"),
  lastName: yup
    .string()
    .matches(
      /^[A-Za-z ]*$/,
      "Last Name can only contain alphabetic characters and spaces",
    )
    .required("Last Name is required")
    .test(
      "nameLength",
      "First Name and Last Name together should not exceed 24 characters. This will be printed on the card.",
      function (value) {
        const { firstName } = this.parent;
        return (firstName?.length || 0) + (value?.length || 0) <= 24;
      },
    ),
  email: yup
    .string()
    .email("Email Address is not valid")
    .required("Email Address is required"),
  employeeGroup: yup.string(),
  role: yup.string().required("Role is required"),
  status: yup.string(),
  sendOneTime: yup.boolean().optional(),
});

const generatePlatformUserValidationSchema = (customFieldSettings = []) => {
  const customFieldsSchema =
    generateCustomFieldsValidation(customFieldSettings);
  return platformUsers.concat(
    yup.object({
      customFields: customFieldsSchema,
    }),
  );
};

export {
  users,
  generateUserValidationSchema,
  generatePlatformUserValidationSchema,
};
